var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLipaMaji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.553,
    height: 65.042,
    viewBox: "0 0 44.553 65.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.389,61.358l-6.2-3.986a1.654,1.654,0,0,0-1.786,0l-5.326,3.407L8.766,57.372a1.654,1.654,0,0,0-1.885,0L3.308,60.1V5.108L6.963,7.473a1.654,1.654,0,0,0,1.8,0l5.309-3.424L19.4,7.473a1.654,1.654,0,0,0,1.852,0l5.21-3.788,5.293,3.738a1.654,1.654,0,0,0,1.852,0l3.655-2.365V36.384a1.654,1.654,0,1,0,3.308,0V2.081A1.654,1.654,0,0,0,38.041.692L32.765,4.082,27.456.311a1.654,1.654,0,0,0-1.919,0L20.244,4.082,14.968.692a1.654,1.654,0,0,0-1.737,0L7.873,4.115,2.547.692A1.654,1.654,0,0,0,0,2.081V63.393a1.654,1.654,0,0,0,.91,1.489,1.654,1.654,0,0,0,.744.165,1.654,1.654,0,0,0,.992-.331l5.293-3.953,5.243,3.308a1.654,1.654,0,0,0,1.786,0l5.326-3.407L25.6,64.071a1.654,1.654,0,0,0,1.786-2.779Z",
    transform: "translate(0 -0.005)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.74,28.511l-3.986-4.2-3.986,4.2a6.186,6.186,0,0,0,0,8.386,5.441,5.441,0,0,0,7.972,0,6.153,6.153,0,0,0,0-8.386Z",
    transform: "translate(13.164 15.89)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,9.308H22.221a1.654,1.654,0,0,0,0-3.308H4.9a1.654,1.654,0,1,0,0,3.308Z",
    transform: "translate(2.125 3.916)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.614,19.21H4.9a1.654,1.654,0,1,0,0,3.308h24.71a1.654,1.654,0,1,0,0-3.308Z",
    transform: "translate(2.125 12.555)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.876,6H18.914a1.654,1.654,0,0,0,0,3.308h4.962a1.654,1.654,0,1,0,0-3.308Z",
    transform: "translate(11.287 3.916)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,14.42a1.654,1.654,0,1,0,0,3.308H9.866a1.654,1.654,0,1,0,0-3.308Z",
    transform: "translate(2.125 9.422)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.954,14.42a1.654,1.654,0,1,0,0,3.308h4.962a1.654,1.654,0,1,0,0-3.308Z",
    transform: "translate(5.428 9.422)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.826,28.838a1.654,1.654,0,1,0,0-3.308H4.864a1.654,1.654,0,1,0,0,3.308Z",
    transform: "translate(2.099 16.688)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.135,28.471H17.827a1.654,1.654,0,0,0-1.307.695l.81-2.051a1.724,1.724,0,0,0-3.308-.976L11.509,34.21A1.654,1.654,0,0,0,12.6,36.278a1.538,1.538,0,0,0,.48,0A1.654,1.654,0,0,0,14.734,35.1l1.555-4.962a1.654,1.654,0,0,0,.447,1.059A1.637,1.637,0,0,0,17.91,34h3.308a1.637,1.637,0,0,0,1.174-2.8,1.611,1.611,0,0,0-1.257-2.729Z",
    transform: "translate(7.478 16.277)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.014,17.728H26.277a1.654,1.654,0,1,0,0-3.308H15.014a1.654,1.654,0,1,0,0,3.308Z",
    transform: "translate(8.737 9.422)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.875,11.524A1.654,1.654,0,0,0,22.221,9.87H4.9a1.654,1.654,0,1,0,0,3.308H22.221A1.654,1.654,0,0,0,23.875,11.524Z",
    transform: "translate(2.125 6.447)",
    fill: "#1787e0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLipaMaji);
export default __webpack_public_path__ + "static/media/lipa_maji.a02f03e6a0772762f0b80df2f3cdfab8.svg";
export { ForwardRef as ReactComponent };